module.exports = __webpack_public_path__ + "img/play-1.48a2c61d.png";